import { useRef } from "react";
import { DOUBLE_TAP_MS } from "./MoveControl";

/**
 * The on-screen fast-forward, the same on every console: held, the game
 * runs at the chosen speed; a double tap locks it on or off.
 */
export default function TurboButton({
  active,
  locked,
  onTurbo,
  onLock,
  className = "",
}: {
  active: boolean;
  locked: boolean;
  onTurbo: (down: boolean) => void;
  onLock: () => void;
  className?: string;
}) {
  const lastTap = useRef(0);
  return (
    <button
      type="button"
      className={`pad turbo${locked ? " locked" : ""} ${className}`}
      aria-label={locked ? "Turbo locked on (double tap to unlock)" : "Turbo (hold to fast-forward, double tap to lock)"}
      aria-pressed={locked}
      onPointerDown={(e) => {
        e.preventDefault();
        if (!active) return;
        e.currentTarget.setPointerCapture(e.pointerId);
        const now = Date.now();
        const double = now - lastTap.current < DOUBLE_TAP_MS;
        lastTap.current = double ? 0 : now;
        if (double) onLock();
        onTurbo(true);
      }}
      onPointerUp={() => onTurbo(false)}
      onPointerCancel={() => onTurbo(false)}
      onLostPointerCapture={() => onTurbo(false)}
      onContextMenu={(e) => e.preventDefault()}
    >
      »
    </button>
  );
}
